import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { View } from '@instructure/ui-view';
import { SimpleSelect } from '@instructure/quiz-common';
import TimeUnitsInput from '../../../../../common/components/shared/TimeUnitsInput';
import ExtraTimeMultiplier from '../ExtraTimeMultiplier';
import { HOUR_IN_SECONDS } from '../../../../../common/components/shared/FormattedDuration';
import t from '@instructure/quiz-i18n/es/format-message';
var getTimeAdjustmentType = function getTimeAdjustmentType(timerSettings) {
  if (timerSettings.timerMultiplierEnabled) {
    return 'timerMultiplierEnabled';
  }
  if (timerSettings.extraTimeEnabled) {
    return 'extraTimeEnabled';
  }
  if (timerSettings.disableTimer) {
    return 'disableTimer';
  }
  return 'none';
};
export var ExtraTimeSettings = /*#__PURE__*/function (_Component) {
  function ExtraTimeSettings() {
    var _this;
    _classCallCheck(this, ExtraTimeSettings);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ExtraTimeSettings, [].concat(args));
    _defineProperty(_this, "onChangeTimeAdjustmentType", function (event, _ref) {
      var value = _ref.value;
      var timeAdjustments = {
        timerMultiplierEnabled: false,
        extraTimeEnabled: false,
        disableTimer: false
      };
      if (value !== 'none') {
        timeAdjustments[value] = true;
      }
      _this.props.onChange(_objectSpread(_objectSpread({}, _this.props.timerSettings), timeAdjustments));
    });
    _defineProperty(_this, "onChangeExtraSeconds", function (seconds) {
      var update = _objectSpread(_objectSpread({}, _this.props.timerSettings), {}, {
        extraTimeInSeconds: seconds
      });
      _this.props.onChange(update);
    });
    _defineProperty(_this, "onChangeMultiplier", function (multiplier) {
      var update = _objectSpread(_objectSpread({}, _this.props.timerSettings), {}, {
        timerMultiplierValue: multiplier
      });
      _this.props.onChange(update);
    });
    return _this;
  }
  _inherits(ExtraTimeSettings, _Component);
  return _createClass(ExtraTimeSettings, [{
    key: "render",
    value: function render() {
      var timerSettings = this.props.timerSettings;
      var timeAdjustmentType = getTimeAdjustmentType(timerSettings);
      return /*#__PURE__*/React.createElement(View, {
        display: "block",
        margin: "medium none"
      }, /*#__PURE__*/React.createElement(SimpleSelect, {
        renderLabel: t('Time adjustments'),
        assistiveText: t('4 options available. Use arrow keys to navigate options.'),
        value: timeAdjustmentType,
        onChange: this.onChangeTimeAdjustmentType,
        "data-automation": "sdk-moderation-time-dropdown"
      }, /*#__PURE__*/React.createElement(SimpleSelect.Option, {
        id: "extra-time-settings-select-option-none",
        value: "none"
      }, t('None')), /*#__PURE__*/React.createElement(SimpleSelect.Option, {
        id: "extra-time-settings-select-option-additional-time",
        value: "extraTimeEnabled"
      }, t('Give additional time')), /*#__PURE__*/React.createElement(SimpleSelect.Option, {
        id: "extra-time-settings-select-option-remove-time",
        value: "disableTimer"
      }, t('Remove time limit (unlimited)')), /*#__PURE__*/React.createElement(SimpleSelect.Option, {
        id: "extra-time-settings-select-option-time-multiplier",
        value: "timerMultiplierEnabled"
      }, t('Time limit multiplier'))), timeAdjustmentType === 'extraTimeEnabled' && /*#__PURE__*/React.createElement(TimeUnitsInput, {
        onChange: this.onChangeExtraSeconds,
        timeInSeconds: timerSettings.extraTimeInSeconds,
        maxTimeInSeconds: this.props.maxTimeInSeconds,
        hoursLabel: t('Hours'),
        hoursDataAutomation: "sdk-moderation-time-hours",
        minutesLabel: t('Minutes'),
        minutesDataAutomation: "sdk-moderation-time-minutes",
        description: t('Additional time'),
        margin: "medium none none none"
      }), timeAdjustmentType === 'timerMultiplierEnabled' && /*#__PURE__*/React.createElement(ExtraTimeMultiplier, {
        onChange: this.onChangeMultiplier,
        timerMultiplierValue: timerSettings.timerMultiplierValue,
        maxMultiplier: this.props.maxMultiplier,
        minMultiplier: this.props.minMultiplier
      }));
    }
  }]);
}(Component);
_defineProperty(ExtraTimeSettings, "propTypes", {
  timerSettings: PropTypes.shape({
    disableTimer: PropTypes.bool,
    extraTimeEnabled: PropTypes.bool,
    extraTimeInSeconds: PropTypes.number,
    increaseTimeAllowance: PropTypes.bool,
    timerMultiplierEnabled: PropTypes.bool,
    timerMultiplierValue: PropTypes.string
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  maxTimeInSeconds: PropTypes.number,
  maxMultiplier: PropTypes.number,
  minMultiplier: PropTypes.number
});
_defineProperty(ExtraTimeSettings, "defaultProps", {
  maxTimeInSeconds: 168 * HOUR_IN_SECONDS,
  maxMultiplier: 99,
  minMultiplier: 1
});
export default ExtraTimeSettings;